import AddressHash from '@/components/AddressHash'
import styles from './index.module.less'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { IResAccountRewards } from '@/api/account/interface'
import { ugeaToGea2 } from '@/utils/number'
import { getFormatTimeZone, getLeftKuohao, getRightKuohao } from '@/utils'
import useMeNavigate from '@/hooks/useMeNavigate'
import { useGlobalStore } from '@/hoxStore/globalStore'

const ShareCard = (props: IResAccountRewards & { address: string }) => {
  const navigate = useMeNavigate()
  const { t } = useTranslation()
  const { timeUtc0 = '-', currentTime = '-' } = getFormatTimeZone(props?.create_time)
  const { curReponsive } = useGlobalStore()
  return (
    <div className={styles.wrap}>
      <div className="area_a_share">
        {/* 地址 */}
        <div className={styles.title}>{t('explorer_114')}</div>
        <div
          className={classNames({
            [styles.textStyleOne]: true,
            font_14: true,
          })}
        >
          <AddressHash
            data={props?.address}
            cutOption
            handleJump={() => {
              navigate(`/accountDetail/${props?.address}`)
            }}
          ></AddressHash>
        </div>
      </div>
      <div className="area_b_share">
        {/* 状态 */}
        <div className={styles.title}>{t('explorer_53')}</div>
        <div
          className={classNames({
            [styles.textStyleTwo]: true,
            font_14: true,
          })}
        >
          <>
            <span>{t('explorer_25')}</span>
            <span className={styles.successIcon}></span>
          </>
          {/* 成功/失败 */}
          {/* {props?.kyc_transaction?.success ? (
            <>
              <span>{t('explorer_25')}</span>
              <span className={styles.successIcon}></span>
            </>
          ) : (
            <>
              <span>{t('explorer_222')}</span>
              <span className={styles.failedIcon}></span>
            </>
          )} */}
        </div>
      </div>
      <div className="area_d_share">
        {/* 交易哈希 */}
        <div className={styles.title}>{t('explorer_103')}</div>
        <div
          className={classNames({
            [styles.textStyleTwo]: true,
            font_14: true,
          })}
        >
          <span>
            <AddressHash
              data={props?.tx_hash}
              cutOption
              handleJump={() => {
                navigate(`/transaction/${props?.tx_hash}?address=${props?.address}`)
              }}
            ></AddressHash>
          </span>
        </div>
      </div>
      <div className="area_e_share">
        {/* 区块 */}
        <div className={styles.title}>{t('explorer_3')}</div>
        <div
          className={classNames({
            [styles.textStyleOne]: true,
            font_14: true,
          })}
          onClick={() => {
            navigate(`/blockchain/${props?.height}`)
          }}
        >
          {props?.height}
        </div>
      </div>
      <div className="area_f_share">
        {/* 类型 */}
        <div className={styles.title}>{t('explorer_104')}</div>
        <div
          className={classNames({
            [styles.textStyleTwo]: true,
            font_14: true,
          })}
        >
          <span>{t('explorer_213')}</span>
        </div>
      </div>
      <div className="area_g_share">
        {/* 奖励 */}
        <div className={styles.title}>{t('explorer_214')}</div>
        <div
          className={classNames({
            [styles.textStyleTwo]: true,
            font_14: true,
          })}
        >
          <span>{ugeaToGea2(props?.invite_reward).value}</span>{' '}
          <span className={styles.textStyleThree}>{ugeaToGea2(props?.invite_reward).sigin}</span>
        </div>
      </div>
      <div className="area_h_share">
        {/* 时间戳 */}
        <div className={styles.title}>{t('explorer_92')}</div>
        <div
          className={classNames({
            [styles.textStyleFive]: true,
            font_14: true,
          })}
        >
          <div>
            {timeUtc0}
            <span className={styles.textStyleFour}>
              {getLeftKuohao(curReponsive)}UTC+0{getRightKuohao(curReponsive)}
            </span>
          </div>
          <div style={{ marginTop: curReponsive?.size === 'mobile' ? '0px' : '4px' }}>
            {/* 当前时区 */}
            {currentTime}
            <span className={styles.textStyleFour}>
              {getLeftKuohao(curReponsive)}
              {t('explorer_95')}
              {getRightKuohao(curReponsive)}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShareCard
